module.exports = __webpack_public_path__ + "static/media/reports.7b936741.png";